import { useState } from "react";
import { toast } from "sonner";
import { Plus, Save, RotateCcw } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { PanelHead } from "../shared";

export function useListEditor(initial, endpoint, toPayload, onSaved) {
  const [rows, setRows] = useState(initial);
  const [saving, setSaving] = useState(false);
  const update = (i, patch) => setRows(r => r.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const remove = (i) => setRows(r => r.filter((_, j) => j !== i));
  const add = (row) => setRows(r => [...r, row]);
  const reset = () => setRows(initial);
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put(endpoint, toPayload(rows)); onSaved(data); toast.success("Ayarlar kaydedildi"); }
    catch (e) { toast.error(errorText(e)); if (e.response?.status === 409) setRows(initial); }
    setSaving(false);
  };
  return { rows, update, remove, add, reset, save, saving };
}

export const EditorShell = ({ title, sub, testId, ed, onAdd, addLabel, children }) => (
  <section className="panel table-panel" data-testid={`${testId}-section`}>
    <PanelHead title={title} sub={sub}>
      <button className="outline-btn compact" onClick={ed.reset} data-testid={`${testId}-reset-button`}><RotateCcw size={14} /> Vazgeç</button>
      <button className="primary-btn compact" onClick={ed.save} disabled={ed.saving} data-testid={`${testId}-save-button`}><Save size={15} /> {ed.saving ? "Kaydediliyor..." : "Kaydet"}</button>
    </PanelHead>
    <div className="table-scroll">{children}</div>
    <AddRow onAdd={onAdd} label={addLabel} testId={testId} />
  </section>
);

const AddRow = ({ onAdd, label, testId }) => {
  const [v, setV] = useState("");
  const submit = (e) => { e.preventDefault(); if (!v.trim()) return; onAdd(v.trim()); setV(""); };
  return <form className="settings-add" onSubmit={submit}>
    <input value={v} onChange={e => setV(e.target.value)} placeholder={label} maxLength={60} data-testid={`${testId}-new-input`} />
    <button className="outline-btn compact" data-testid={`${testId}-add-button`}><Plus size={15} /> Ekle</button>
  </form>;
};
